import { bindMobileEmail } from "@/service/user";
import SendMessage from "../SendMessage.vue";
export default {
  components: {
    SendMessage
  },
  //   props: {
  //     accountType() {
  //       return "MOBILE";
  //     },
  //   },
  data() {
    return {
      userId: "",
      visible: false,
      accountType: "MOBILE",
      form: {
        email: "",
        mobile: "",
        verificationCode: "",
        mobileAreaCode: "+86"
      }
    };
  },
  methods: {
    close() {
      this.$refs.sendMessage.clean();
      // this.$refs.sendMessage.clearVerificationCode();
      this.visible = false;
    },
    async submit() {
      const val = await this.$refs.sendMessage.validate();
      if (val) {
        // console.log(this.form);
        const {
          mobile,
          email,
          verificationCode,
          mobileAreaCode
        } = this.form;
        const data = {
          mobile,
          email,
          verificationCode,
          mobileAreaCode,
          authMode: this.accountType,
          checkMode: "CHECK_UPDATE",
          userId: this.userId
        };
        const res = await bindMobileEmail(data);
        if (res.data.result === 0) {
          // 把绑定后手机号/邮箱emit给MyInfo
          this.$emit("updateMobile", {
            email: res.data.retVal.email || "",
            mobile: res.data.retVal.mobile || "",
            bind: true
          });
          this.visible = false;
          this.$Message.success({
            content: $t("gdpuew4", "绑定成功")
          });
        }
      }
    },
    init(accountType, userId) {
      this.userId = userId;
      this.accountType = accountType;
      this.visible = true;
    }
  }
};